import {
  UPLOAD_RESUME_ERROR,
  UPLOAD_RESUME_PENDING,
  UPLOAD_RESUME_SUCCESS,
  GET_RESUME_ERROR,
  GET_RESUME_PENDING,
  GET_RESUME_SUCCESS,
  DELETE_RESUME_ERROR,
  DELETE_RESUME_PENDING,
  DELETE_RESUME_SUCCESS,
} from "../actions/resume";

const initialState = {
  pending: false,
  resumes: [],
  error: null,
};

export function reducer(state = initialState, action) {
  switch (action.type) {
    case UPLOAD_RESUME_PENDING:
      return {
        ...state,
        pending: true,
      };
    case UPLOAD_RESUME_SUCCESS:
      return {
        ...state,
        pending: false,
        resumes: state.resumes.concat(action.payload),
      };
    case UPLOAD_RESUME_ERROR:
      return {
        ...state,
        pending: false,
        error: action.message,
      };
    case GET_RESUME_PENDING:
      return {
        ...state,
        pending: true,
      };
    case GET_RESUME_SUCCESS:
      return {
        ...state,
        pending: false,
        resumes: action.payload,
      };
    case GET_RESUME_ERROR:
      return {
        ...state,
        pending: false,
        error: action.message,
      };
    case DELETE_RESUME_PENDING:
      return {
        ...state,
        pending: true,
      };
    case DELETE_RESUME_SUCCESS:
      return {
        ...state,
        pending: false,
        resumes: state.resumes.filter(
          (resume) => resume.id !== action.payload.id
        ),
      };
    case DELETE_RESUME_ERROR:
      return {
        ...state,
        pending: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export const getResumePending = (state) => state.resume.pending;
export const getResumeError = (state) => state.resume.error;
export const getResumes = (state) => state.resume.resumes;
